// extracted by mini-css-extract-plugin
export default {"container":"SalesTodayStatusData_container__LaERF","label":"SalesTodayStatusData_label__3VP7d"};